module.exports = __webpack_public_path__ + "img/go7.40c2c160.png";